<fury-page>
    <fury-title class="title">
        <h2>{{covereditemid ? 'Update ' : 'Add '}} Optional Item</h2>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="optionalItemForm" *ngIf="optionalItemForm">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
            style="margin-bottom: 20px;align-items: baseline; width: 100% !important;">
            <div class="flex">
              <div class="innerdiv">
                <div class="uploadsec" style="margin-right: 20px">
                  <div class="imgsec">
                    <img [src]="bannerImage ?  bannerImage : '../../../../../assets/img/no_thumbnail.jpg'" alt="">
                  </div>
                  <div class="uploadbtnsec">
                    <input type="file" #image_one (change)="onImageUpload($event)" accept=".png, .jpg, .jpeg"
                      style="display:none">
                    <button type="button" class="uploadfilebtn" mat-raised-button (click)="image_one.click()">Upload image</button>
                  </div>
                </div>
              </div>
            </div>
            </fxLayout>

            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Title</mat-label>
              <input matInput placeholder="Title" (keyup)="apiservice.restrictChar($event, 255)"
                formControlName="title">
              <mat-error
                *ngIf="optionalItemForm.controls['title'].touched && optionalItemForm.controls['title'].hasError('required')">
                This is a required field.</mat-error>
              <mat-error *ngIf="optionalItemForm.controls['title'].hasError('maxlength')">
                This is a required field.</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Banner Description</mat-label>
              <textarea matInput placeholder="Banner Description" formControlName="bannerDescription" rows="3"></textarea>
              <mat-error
                *ngIf="optionalItemForm.controls['bannerDescription'].touched && optionalItemForm.controls['bannerDescription'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Description</mat-label>
              <textarea matInput placeholder="Description" formControlName="description" rows="3"></textarea>
              <mat-error
                *ngIf="optionalItemForm.controls['description'].touched && optionalItemForm.controls['description'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Meta Title</mat-label>
              <input matInput placeholder="Meta Title" formControlName="metaTitle"
                (keyup)="apiservice.restrictChar($event, 65)">
                <mat-hint> Meta Title Character Count: {{(65 - optionalItemForm.controls['metaTitle'].value.length) > 0
                  ? (65 -
                  optionalItemForm.controls['metaTitle'].value.length) : 0}}</mat-hint>
              <mat-error
                *ngIf="optionalItemForm.controls['metaTitle'].touched && optionalItemForm.controls['metaTitle'].hasError('required')">
                This is a required field.</mat-error>
               
            </mat-form-field>
            

            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Meta Description</mat-label>
              <textarea matInput placeholder="Meta Description" formControlName="metaDescription"
                (keyup)="apiservice.restrictChar($event, 155)"></textarea>
                <mat-hint> Meta Description Character Count: {{(155 -
                  optionalItemForm.controls['metaDescription'].value.length) > 0 ?
                  (155 - optionalItemForm.controls['metaDescription'].value.length) : 0}}</mat-hint>
              <mat-error
                *ngIf="optionalItemForm.controls['metaDescription'].touched && optionalItemForm.controls['metaDescription'].hasError('required')">
                This is a required field.</mat-error>
               
            </mat-form-field>

            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Plan Type</mat-label>
              <mat-select matNativeControl formControlName="planType">
                <mat-option value="">N/A</mat-option>
                <mat-option value="optional">Optional</mat-option>
                <mat-option value="main">Main</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-slide-toggle formControlName="isActive">Active</mat-slide-toggle>
          </div>

          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button"
                        (click)="addOrUpdateOptionalItem()"><span>{{!covereditemid ? 'Add' : 'Update'}}</span></button>
            <button mat-button type="button" class="can-button" (click)="back()"><span>Cancel</span></button>
          </div>
            
          </form>
    </div>
  </div>
